import { apiFetch } from './apiFetch';
import type { Project } from '@deposits/shared';

export async function fetchProjects(): Promise<Project[]> {
  return apiFetch<Project[]>('/projects');
}
